import { render, staticRenderFns } from "./mixes.vue?vue&type=template&id=38689183&scoped=true"
import script from "./mixes.vue?vue&type=script&setup=true&lang=js"
export * from "./mixes.vue?vue&type=script&setup=true&lang=js"
import style0 from "./mixes.vue?vue&type=style&index=0&id=38689183&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38689183",
  null
  
)

export default component.exports